import React from 'react';
import { Avatar } from '@material-ui/core';
import { Person } from '@material-ui/icons';

export function ImagePlaceholder({ classes = '' }) {
  return (
    <Avatar
      className={`image-input-wrapper ${classes}`}
      style={{ borderRadius: 4 }}
    >
      <Person />
    </Avatar>
  );
}
